import { DICE, getDie, getDieFaceLabel } from './dice';
import DieMiniature from './DieMiniature';
import './DieSelector.css';
import { applyAttackStyle } from './coreAttackStyles';

const DieSelector = ({
  selectedDie,
  onSelect,
  disabled = false,
  attackStyle = null,
}) => (
  <div
    className="coreboundDieSelector"
    role="group"
    aria-label="Choose your die"
  >
    <span className="coreboundDieSelectorTitle">CHOOSE DIE</span>
    {DICE.map((die, index) => {
      const selected = getDie(selectedDie).id === die.id;
      const faces = die.faces?.map((value) =>
        applyAttackStyle(value, attackStyle)
      );
      const faceLabel = attackStyle
        ? faces?.join(' · ') ||
          `Six random faces · ${applyAttackStyle(
            1,
            attackStyle
          )}–${applyAttackStyle(100, attackStyle)}`
        : getDieFaceLabel(die.id);
      return (
        <button
          key={die.id}
          type="button"
          className={`coreboundDieChoice coreboundDieChoice-${die.id} ${
            selected ? 'is-selected' : ''
          }`}
          style={{
            '--die-color': die.color,
            '--die-body': die.body,
            '--die-delay': `${index * -1.4}s`,
          }}
          aria-label={`${die.name}, ${die.label}. ${faceLabel}`}
          aria-pressed={selected}
          title={`${die.description} Faces: ${faceLabel}`}
          disabled={disabled}
          onClick={() => onSelect(die.id)}
        >
          <span className="coreboundDieHologram" aria-hidden="true">
            <span className="coreboundDiePedestal" />
            <span className="coreboundDieHover">
              <DieMiniature dieId={die.id} />
            </span>
          </span>
          <span className="coreboundDieChoiceText">
            <strong>{die.name}</strong>
            <small>{die.label}</small>
            <span className="coreboundDieChoiceFaces">
              {faces?.join(' / ') ||
                (attackStyle
                  ? `${applyAttackStyle(1, attackStyle)}–${applyAttackStyle(
                      100,
                      attackStyle
                    )} on every face`
                  : '1–100 on every face')}
            </span>
          </span>
          {selected && (
            <span className="coreboundDieSelectedMark" aria-hidden="true">
              ✓
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default DieSelector;
